import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { DconConfigAPI } from './features/dfte-grid-view/config/config';
@Injectable({
  providedIn: 'root'
})
export class FeatureFlagGuard implements CanActivate {
 
  constructor(private router: Router) {}
 
  canActivate(next:ActivatedRouteSnapshot,state:RouterStateSnapshot): boolean {
    if (DconConfigAPI.USE_CONFIGBUILD_FEATURE) {
      return true;
    } else {
      this.router.navigate(['/']);  // Redirect to homepage
      return false;
    }
  }
}
